import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit {
  @Input()
  placeholder: string = ""
  @Output()
  searchInputChanged: EventEmitter<string> = new EventEmitter<string>()


  constructor() { }

  ngOnInit() {
  }

  inputChanged(event) {
    this.searchInputChanged.emit(event.target.value);
  }
}